<template>
  <div>
    <page
            size="A4"
            class="aligncenter fontweight700"
            v-for="index in datashowAllDetail.length"
          >
            <div class="aligncenter">
              <div class="rowprpo aligncenter ">
                <div class="col-md-12report mt20">
                  <h3>
                    {{ print_detail_header.com_eng_1 }}
                  </h3>
                </div>
              </div>
              <div class="rowprpo  aligncenter fontsize10">
                <div class="col-md-12report">
                  {{ print_detail_header.com_eng_2 }}
                </div>
              </div>
              <div class="rowprpo  aligncenter  fontsize14">
                <div class="col-md-12report">
                  <h4>
                    {{ print_detail_header.com_thai }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo  aligncenter  fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_detail_header.com_add_name }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo  aligncenter  fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_detail_header.com_add_no }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo  aligncenter fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_detail_header.com_add_city }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo  aligncenter fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_detail_header.com_add_country }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo  aligncenter fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_detail_header.com_add_tel }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo  aligncenter fontsize10">
                <div class="col-md-12report">
                  <h4>
                    {{ print_detail_header.com_add_email }}
                  </h4>
                </div>
              </div>
              <div class="rowprpo  aligncenter fontsize10">
                <div class="col-md-12report">
                  <h5>
                    {{
                      print_detail_header.com_add_tax_id
                        ? print_detail_header.com_add_tax_id
                        : "-"
                    }}
                  </h5>
                </div>
              </div>
              <div class="rowprpo aligncenter mt10">
                <div class="col-md-12report">
                  <h3>
                    {{ print_detail_header.com_title }}
                  </h3>
                </div>
              </div>
              <div class="rowprpo aligncenter">
                <div class="col-md-12report">
                  <h3>
                     {{ print_detail_header.com_title_th }}
                  </h3>
                </div>
              </div>
              <div class="rowprpo mr30prpo mt20">
                <div class="col-md-8report"></div>
                <div class="col-md-4report">
                  <h5 class="alignright colprpo ">
                     No. / เลขที่ : {{ print_detail_header.inv_id }}
                  </h5>
                </div>
              </div>
              <div
                class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13"
              >
                <v-divider style="margin-top: 5px;" class="borderwidththin"></v-divider>
              </div>
              <div
                class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13"
              >
                <div class="col-md-1report textalignleft ">
                  To/ถึง :
                </div>
                <div class="col-md-5report textalignleft fixonerow">
                  {{
                    print_detail_header.customer_name
                      ? print_detail_header.customer_name
                      : "-"
                  }}
                </div>
                <div class="col-md-1report textalignleft">
                </div>
                <div class="col-md-5report  fontsize13 textalignleft">
                  Date/วันที่ : {{
                    print_detail_header.invoice_date
                      ? print_detail_header.invoice_date
                      : "-"
                  }}
                </div>
              </div>
              <div
                class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13 mt-5prpo"
              >
                <div class="col-md-1report">
                </div>
                <div class="col-md-5report textalignleft fixthreerow">
                  {{
                    print_detail_header.addressall
                      ? print_detail_header.addressall
                      : "-"
                  }}
                </div>
                <div class="col-md-1report">
                </div>
                <div class="col-md-5report textalignleft" >
                  Invoice No. / ใบแจ้งหนี้ :
                  {{
                    print_detail_header.invoice_no.length > 60
                      ? print_detail_header.invoice_no.slice(0, 60) + '...'
                      : print_detail_header.invoice_no
                  }}
                 
                </div>
              </div>
              <div
                class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13 mt-5prpo"
              >
                <div class="col-md-1report textalignleft">
                  TAX ID :
                </div>
                <div class="col-md-5report textalignleft fixonerow" v-if="branch_cus != '' && branch_cus != 'null' && branch_cus != null">
                  {{
                    print_detail_header.customer_taxid
                      ? print_detail_header.customer_taxid
                      : "-"
                  }} / {{ branch_cus }}
                </div>
                <div class="col-md-5report textalignleft fixonerow" v-else>
                  {{
                    print_detail_header.customer_taxid
                      ? print_detail_header.customer_taxid
                      : "-"
                  }} 
                </div>
                <div class="col-md-1report">
                </div>
              </div>
              <div
                class="rowprpo ml30prpo mr30prpo  aligncenter col-md-12report fontsize13"
              >
                <v-divider style="margin-top: 5px;" class="borderwidththin"></v-divider>
              </div>
            </div>
            <div
              class="rowprpo caption  ml30prpo mr30prpo"
              style="margin-top:10px"
            >
              <table class="captionhtable ">
                <tr>
                  <th
                    scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable widthDesDetail thborder-top thborder-left fontsize14 captionhtable"
                  >
                    <span class="aligncenter fontweight700">Description /รายการ</span>
                  </th>
                  <th
                    scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable width30 thborder-top thborder-left fontsize14 captionhtable"
                  >
                    <span class="aligncenter fontweight700">Quantity / จำนวน</span>
                  </th>
                  <th
                    scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable width40 thborder-top thborder-left thborder-right fontsize14 captionhtable"
                  >
                    <span class="aligncenter fontweight700">Amount / จำนวนเงิน </span>
                  </th>
                </tr>
              </table>

              <table class="captionhtable " :style="{height:heighttabledetail}">
                <tr
                  v-for="(data, i) in datashowAllDetail[index - 1]"
                  style="height:20px;"
                >
                  <td
                    style="position: relative;"
                    scope="colgroup"
                    class="textalignleft  widthcolDesDetail caption prborderbottomsumpo tdborder-left fontsize14 paddingleftintable"
                  >
                    <span class="textalignright fontweight700"> {{ data.description }}</span>
                  </td>
                  <td
                    style="position: relative;"
                    scope="colgroup"
                    class="textalignright  width30 caption prborderbottomsumpo tdborder-left fontsize14 paddingleftintable"
                  >
                    <span class="textalignright paddingrightintable fontweight700">
                      {{ data.quantity }}</span
                    >
                  </td>
                  <td
                    scope="colgroup"
                    class="textalignright width40 caption prborderbottomsumpo tdborder-left fontsize14 tdborder-right  paddingrightintable"
                  >
                    <span class="textalignright fontweight700">
                      {{
                        data.amount
                          ? data.amount.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "0.00"
                      }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td
                    scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-bottom"
                  ></td>
                  <td
                    scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-bottom"
                  ></td>
                  <td
                    scope="colgroup"
                    class="textalignleft width20 caption prborderbottomsumpo tdborder-left tdborder-right tdborder-bottom"
                  ></td>
                </tr>
              </table>
            </div>
            <div class="">
              <div class="rowprpo caption  ml30prpo mr30prpo">
                <table
                  class="captionhtable "
                  v-if="index == datashowAllDetail.length"
                >
                  <tr>
                    <td
                      scope="colgroup"
                      class="textalignleft  captiontotal fontsize14 prborderbottomsumpo tdborder-left   widthTotal tdborder-bottom paddingleftintable"
                    >
                      <h4 class="textalignleft">
                        <span> Sub Total / รวมเป็นเงิน</span>
                      </h4>
                    </td>
                    <td
                      scope="colgroup"
                      class="textalignleft  captiontotal fontsize14 prborderbottomsumpo tdborder-left   widthValOri tdborder-right tdborder-bottom paddingrightintable"
                    >
                      <span class="textalignright">
                        <h4>
                          {{
                            print_detail_header.sub_total
                              ? print_detail_header.sub_total.toLocaleString(
                                  "en-US",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )
                              : "0.00"
                          }}
                        </h4></span
                      >
                    </td>
                  </tr>

                  <tr v-if="!checklawoffice">
                    <td
                      scope="colgroup"
                      class="textalignleft  captiontotal fontsize14 prborderbottomsumpo tdborder-left   widthTotal tdborder-bottom paddingleftintable"
                    >
                      <h4 class="textalignleft">
                        <span class="textalignleft">
                          Value Added Tax / ภาษีมูลค่าเพิ่ม ({{
                            print_detail_header.tax_rate
                              ? print_detail_header.tax_rate
                              : "0.00"
                          }}
                          %)</span
                        >
                      </h4>
                    </td>
                    <td
                      scope="colgroup"
                      class="textalignleft  captiontotal fontsize14 prborderbottomsumpo tdborder-left   widthValOri tdborder-right tdborder-bottom paddingrightintable"
                    >
                      <span class="textalignright">
                        <h4>
                          {{
                            print_detail_header.tax_rate_amount
                              ? print_detail_header.tax_rate_amount.toLocaleString(
                                  "en-US",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )
                              : "0.00"
                          }}
                        </h4>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td
                      scope="colgroup"
                      class="textalignleft widthTotal  captiontotal fontsize14 prborderbottomsumpo tdborder-left   paddingleftintable"
                    >
                      <h4 class="textalignleft">
                        <span> Grand Total / ยอดรวม</span><br />
                      
                      </h4>
                    </td>
                    <td
                      scope="colgroup"
                      class="textalignleft widthValOri captiontotal fontsize14 prborderbottomsumpo tdborder-left  tdborder-right tdborder-bottom paddingrightintable"
                    >
                      <span class="textalignright">
                        <h4>
                          {{
                            print_detail_header.amount_total
                              ? print_detail_header.amount_total.toLocaleString(
                                  "en-US",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )
                              : "0.00"
                          }}
                        </h4></span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td
                      colspan="2"
                      scope="colgroup"
                      class="full-width-td textalignleft  paddingtoptintable fontsize14 caption prborderbottomsumpo tdborder-left tdborder-right tdborder-bottom   paddingleftintable mt-2"
                    >
                      <h4 class="textalignleft" v-if="check_cus_name">
                        <span 
                          class="fixonerowcenter"
                          style="background-color:#dedbdb;display: table;margin: 0px auto 0px auto;"
                          >({{ textamount_total_en }}) {{ currency_show }}</span
                        >
                      </h4>
                      <h4 class="textalignleft" v-else>
                        <span 
                          v-if="currency_show != 'THB'"
                          class="fixonerowcenter"
                          style="background-color:#dedbdb;display: table;margin: 0px auto 0px auto;"
                          >({{ textamount_total_en }}) {{ currency_show }}</span
                        >
                        <span 
                          v-else
                          class="fixonerowcenter"
                          style="background-color:#dedbdb;display: table;margin: 0px auto 0px auto;"
                          >({{ textamount_total_en }})</span
                        >
                      </h4>
                    </td>
                  </tr>
                </table>

     
              </div>
            </div>
            <div class="rowprpo caption  ml30prpo mr30prpo ">
              <table class="captionhtable ">
                <tr>
                  <th
                    scope="colgroup"
                    class="prbordertop2pxhtable prborderbottom2pxhtable widthDesDetail thborder-left thborder-right fontsize14 captionhtable"
                  >
                    <v-row class="textalignleft higthRP fontweight700">
                      <v-col cols="12" md="4"
                        ><h4 class="paddingrightintableleft">
                          Payments Conditions:
                        </h4></v-col
                      >
                    </v-row>
                    <v-row class="textalignleft higthR fontweight700 paddingrightintableleft">
                            <v-col cols="12" md="7">
                              <v-radio-group
                                small
                                v-model="payment_by_print"
                                row
                                class="customClass "

                              >
                                <v-radio
                                  key="cash"
                                  label="Cash/เงินสด"
                                  value="cash"
                                ></v-radio>
                                <v-radio
                                  key="Bank"
                                  label="Transfer/โอนเงิน"
                                  value="Bank"
                                ></v-radio>
                                <v-radio
                                  key="cheque"
                                  label="Cheque/เช็คธนาคาร"
                                  value="cheque"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>
                            <v-col cols="12" md="5" class="mt-8" >
                              <br/>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <span class=" frontsize13" >
                                    <u>{{ bank_name_show }}</u>
                                    &nbsp;&nbsp;
                                    No./เลขที่&nbsp;<u>{{ bank_no_show }}</u>
                                  </span>
                                </v-col>
                              </v-row>
                            </v-col>
                    </v-row>
                    <v-row class="textalignleft higthR fontweight700">
                      <v-col cols="12" md="10">
                        <v-row>
                          <v-col cols="12" md="12"
                            ><span class="paddingrightintableleft"
                              >Payment Detail / รายละเอียด: &nbsp;
                              {{
                                print_detail_header.payment_detail
                                  ? print_detail_header.payment_detail
                                  : "-"
                              }}
                            </span
                            ></v-col
                          >
                        </v-row>
                      </v-col>
                    </v-row>
                    <br />
                  </th>
                </tr>
              </table>
              <div class="rowprpo alignright mt30 fontweight700 mrb">
                  <div class="col-md-12report alignright">
                    <div
                      class="alignright borderblack borderblockpr fontsize10 "
                    >
                      <div class="  aligncenter col-md-12report mt20">
                        <div class="col-md-12report">
                          _________________________________________
                        </div>
                        <div class="col-md-12report">
                          Authorized Signature / ผู้รับเงิน
                        </div>
                        <div class="col-md-12report">
                          Date / วันที่ _____________________________
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="rowprpo  aligncenter col-md-12report fontsize10 fontweight700">
                  <div class="col-md-12report">
                    This receipt will be valid when the company has received the payment into the bank account.
                  </div>
                </div>
                <div
                  class="rowprpo  aligncenter col-md-12report fontsize10 mt-5prpo fontweight700"
                >
                  <div class="col-md-12report">
                    ใบเสร็จรับเงินนี้จะสมบูรณ์ต่อเมื่อบริษัทฯได้รับเงินเข้าบัญชีเรียบร้อยแล้ว
                  </div>
                </div>
            </div>
          </page>
    </div>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";

export default {
  name: "InvoiceSalseorderTab",
  props: [
    "datashowAllDetail",
    "print_detail_header",
    "heighttabledetail",
    "currency_print",
    "check_cus_name",
    "textamount_total_en",
    "checklawoffice",
    "exchange_rate",
    "branch_cus",
    "payment_by_print",
    "bank_name_show",
    "bank_no_show",
    "currency_show",
  ],
  // async beforeUpdate() {
  //   if (this.datainv_h.customerid != 0) {
  //     await this.loaddataSO();
  //   } else {
  //   }
  // },
  async beforeMount() {
  
  },
  async mounted() {
    console.log(this.datashowAll)
    // this.$showLoader();
   
  },
  components: {
    SuccessDialog,
  },
  data() {
    return {
      vat_type_list:[{id:"I",name:"Include Vat"},{id:"E",name:"Exclude Vat"}],
      isdisableeditpriceperunit:true,
      inv_title_list: [],
      status_loadso: 0,
      editedIndex: -1,
      dataeditItem: {
        no: 0,
        description: "",
        unit: 0,
        item_um: "",
        PricePerUnit: 0,
        amount: 0,
      },
      dialogEdit: false,
      dialogDelete: false,
      isShowPassword: false,
      fullPage: true,
      customer: [],
      customer_list: [],
      customer_code: "",
      customer_id: "",
      customer_name: "",
      saleorder_id: "",
      currency: "",
      tax_id: "",
      branch: "",
      invoice_address: "",
      payment_term: 0,
      vat: 0,
      po_no: "",
      attention: "",
      contact_position: "",
      vat_type:"",
      vatCal: 0,
      desserts: [],
      editedItem: {
        code: "",
        description: "",
        amount: 0,
      },
      editedItemadd: {
        headercheckbox: false,
        inv_title: "",
        description: "",
        no: 0,
        unit: 0,
        amount: 0,
        PricePerUnit: 0,
      },
      defaultItem: {
        headercheckbox: false,
        inv_title: "",
        description: "",
        no: 0,
        unit: 0,
        amount: 0,
        PricePerUnit: 0,
      },
      // dialogAdd: false,
      dialogSendMail: false,
      // text_color: "text-h5 green--text text-center",
      // title: "green",
      // message: "green",
      headers: [
        {
          text: "No.",
          value: "no",
          class: "bg-colorth texttablehcenter ",
          width: "8%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Service Details",
          value: "description",
          class: "bg-colorth texttablehcenter",
          width: "30%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Qty",
          value: "unit",
          class: "bg-colorth texttablehcenter ",
          width: "15%",
          divider: true,
          align: "end",
          sortable: false,
        },
        // {
        //   text: "Unit",
        //   value: "item_um",
        //   class: "bg-colorth texttablehcenter ",
        //   width: "10%",
        //   divider: true,
        //   align: "end",
        //   sortable: false,
        // },
        {
          text: "Price Per Unit",
          value: "PricePerUnit",
          class: "bg-colorth texttablehcenter",
          width: "14%",
          divider: true,
          align: "end",
          sortable: false,
        },
        {
          text: "Total Price",
          value: "amount",
          class: "bg-colorth texttablehcenter",
          width: "15%",
          divider: true,
          align: "end",
          sortable: false,
        },

        {
          value: "actions",
          class: "bg-colorth texttablehcenter",
          align: "center",
          width: "13%",
          divider: true,
          sortable: false,
        },
      ],
      dialogAddSo: false,
      text_colorSo: "text-h5 green--text text-center",
      titleSo: "green",
      messageSo: "green",
    };
  },
  methods: {

    async loadCustomer() {
      let result = [];
      result = await api.getAllCustomerListactive();

      this.customer = result.data;

      result.data.forEach((item) => {
        this.customer_list.push(item.name);
      });
      this.$hideLoader();
    },

   
    async onSelectpayment() {
      this.$emit("inv_sotab_paymentcus", this.payment_term);
      // alert(this.payment_term)
    },
    async onSelectvat() {
      this.$emit("inv_sotab_vatcus", this.vat);
      // alert(this.vat)
    },
    async onSelectpono() {
      this.$emit("inv_sotab_ponocus", this.po_no);
      // alert(this.po_no)
    },
    async onSelectattention() {
      this.$emit("inv_sotab_attentioncus", this.attention);
    },
    async onSelectcontact_position() {
      this.$emit("inv_sotab_contact_positioncus", this.contact_position);
    },
    async onSelectvat_type() {
      this.$emit("inv_sotab_vat_type", this.vat_type);
    },

    setupAlertDialog(status, titleSo, messageSo, text_colorSo) {
      this.titleSo = titleSo;
      this.messageSo = messageSo;
      this.dialogAddSo = status;
      this.text_colorSo = text_colorSo;
    },
  },

  beforeCreate() {
    // console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
body {
  background: rgb(204, 204, 204);
}
.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="A4"][layout="landscape"] {
  width: 29.7cm;
  height: 21cm;
}
.page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}
.page[size="A3"][layout="landscape"] {
  width: 42cm;
  height: 29.7cm;
}
.page[size="A5"] {
  width: 14.8cm;
  height: 21cm;
}
.page[size="A5"][layout="landscape"] {
  width: 21cm;
  height: 14.8cm;
}

@page {
  size: 7in 9.25in;
  margin: 27mm 16mm 27mm 16mm;
}
page {
  position: relative;
  background: white;
  display: block;
  margin: 0 auto;
  line-height: 1.5;
  /* margin-bottom: 0.5cm; */
  border: 1px solid;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  font-family: "Roboto", sans-serif;
}
page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}
@media print {
  body,
  page {
    margin: 0;
    box-shadow: 0;
  }
  html,
  body {
    width: 210mm;
    height: 297mm;
  }
}

.page {
  display: inline-block;
  position: relative;
  height: 297mm;
  width: 210mm;
  font-size: 12pt;
  margin: 2em auto;
  padding: calc(var(--bleeding) + var(--margin));
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  background: white;
}

@media screen {
  .page::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: calc(100% - var(--bleeding) * 2);
    height: calc(100% - var(--bleeding) * 2);
    margin: var(--bleeding);
    /* outline: thin dashed black; */
    pointer-events: none;
    z-index: 9999;
  }
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}
.btnuploadfile {
  border: 2px solid;
}
.v-btn:not(.v-btn--round).v-size--default.buttonred {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}
.v-btn:not(.v-btn--round).v-size--default.buttonwhite {
  width: 100%;
  background-color: #f5f5f5;
  color: black;
}

h3 {
  font-size: 1.17em;
}
h4 {
  font-size: 1em;
}
.frontsize{
    font-size: 14px;
}
.test {
  border-style: double;
}

.borderblack {
  border-style: solid;
  border-width: thin;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.btn-light {
  color: #333;
  background-color: #fafafa;
  border-color: #ddd;
}

@media (min-width: 768px) {
  .wmin-md-400 {
    min-width: 400px !important;
  }
}

.btn-primary {
  color: #fff;
  background-color: #2196f3;
}

.btn-labeled > b {
  position: absolute;
  top: -1px;
  background-color: blue;
  display: block;
  line-height: 1;
  padding: 0.62503rem;
}
.alignleft {
  float: left;
}
.alignright {
  float: right;
}
.aligncenter {
  text-align: center;
}
.captionreport {
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}
.caption {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}
.captiontotal {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.8rem;
  font-family: "Roboto", sans-serif;
}
.captionhtable {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}
.rowprpo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin-right: -12px;
  margin-left: -12px;
}
.colprpo {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}
.col-md-1report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.333333333333333%;
  flex: 0 0 8.333333333333333%;
  max-width: 8.333333333333333%;
}
.col-md-2report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.66666666666667%;
  flex: 0 0 16.66666666666667%;
  max-width: 16.66666666666667%;
}

.col-md-3report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-4report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333333333333%;
  flex: 0 0 33.33333333333333%;
  max-width: 33.33333333333333%;
}

.col-md-5report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 41.66666666666667%;
  flex: 0 0 41.66666666666667%;
  max-width: 41.66666666666667%;
}

.col-md-6report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}
.col-md-7report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 58.33333333333333%;
  flex: 0 0 58.33333333333333%;
  max-width: 58.33333333333333%;
}
.col-md-8report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 66.66666666666667%;
  flex: 0 0 66.66666666666667%;
  max-width: 66.66666666666667%;
}
.col-md-9report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}
.col-md-10report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 83.33333333333333%;
  flex: 0 0 83.33333333333333%;
  max-width: 83.33333333333333%;
}
.col-md-11report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 91.66666666666667%;
  flex: 0 0 91.66666666666667%;
  max-width: 91.66666666666667%;
}
.col-md-12report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.mt-5prpo {
  margin-top: -5px !important;
}

.mrb{
  margin-right: 0px !important;
}
.mt-30prpo {
  margin-top: -30px !important;
}

.mt30 {
  margin-top: 30px !important;
}
.mt20 {
  margin-top: 20px !important;
}
.mt10 {
  margin-top: 10px !important;
}
.mt25 {
  margin-top: 25px !important;
}

.mt-25prpo {
  margin-top: -25px !important;
}

.mr30prpo {
  margin-right: 30px !important;
}
.mrRprpo {
  margin-right: 30px !important;
}

.ml30prpo {
  margin-left: 30px !important;
}

.ml2prpo {
  margin-left: 2px !important;
}

.ml10prpo {
  margin-left: 10px !important;
}
.ml-40prpo {
  margin-left: -40px !important;
}
.width45 {
  word-wrap: break-word;
  width: 45%;
}
.width50 {
  word-wrap: break-word;
  width: 50%;
}
.width55 {
  word-wrap: break-word;
  width: 50%;
}
.borderblockpr {
  border: 1px solid black;
  width: 300px;
  height: 80px;
  /* background: white; */
  /* box-sizing: border-box; */
  display: inline-block;
}

.col-md-4pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30%;
  flex: 0 0 30%;
  max-width: 30%;
}
.col-md-8pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70%;
  flex: 0 0 70%;
  max-width: 70%;
}
.col-md-4prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}
.col-md-8prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.textalignleft {
  text-align: left;
}
.textaligncenter {
  text-align: center;
}
table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  /* border: 1px solid black; */
}
.prbordertop {
  border-top: 1px solid black;
}
.prborderbottom {
  border-bottom: 1px solid black;
}
.prbordertop2pxhtable {
  padding-top: 8px;
  /* border-top: 1px solid black; */
}
.prborderbottom2pxhtable {
  padding-bottom: 8px;
  border-bottom: 1px solid black;
}

td {
  /* border: 1px solid black; */
}
td.tdborder-top {
  border-top: 1px solid black;
}
td.tdborder-right {
  border-right: 1px solid black;
}
td.tdborder-left {
  border-left: 1px solid black;
}
td.tdborder-bottom {
  border-bottom: 1px solid black;
}
th {
  /* border: 1px solid black; */
}
th.thborder-top {
  border-top: 1px solid black;
}
th.thborder-right {
  border-right: 1px solid black;
}
th.thborder-left {
  border-left: 1px solid black;
}
th.thborder-bottom {
  border-bottom: 1px solid black;
}
.width15 {
  word-wrap: break-word;
  width: 15%;
}
.width10 {
  word-wrap: break-word;
  width: 10%;
}
.width20 {
  word-wrap: break-word;
  width: 20%;
}
.width30 {
  word-wrap: break-word;
  width: 30%;
}
.width120 {
  word-wrap: break-word;
  width: 120%;
}
.widthcolNo {
  word-wrap: break-word;
  width: 61px;
}
.widthcolNoOth {
  word-wrap: break-word;
  width: 46px;
}

.widthinvNo {
  word-wrap: break-word;
  width: 244px;
}

.widthinvNoOth {
  word-wrap: break-word;
  width: 183px;
}
.widthDate {
  word-wrap: break-word;
  width: 183px;
}
.widthDateOth {
  word-wrap: break-word;
  width: 137px;
}
.widthCredit {
  word-wrap: break-word;
  width: 148%;
}
.widthCurrency {
  word-wrap: break-word;
  width: 112%;
}
.widthCurrencyOth {
  word-wrap: break-word;
  width: 183px;
}
.widthAmount {
  word-wrap: break-word;
  width: 243px;
}
.widthAmountOth {
  word-wrap: break-word;
  width: 183px;
}
.widthinvDate {
  word-wrap: break-word;
  width: 112%;
}
.widthcolDesDetail {
  word-wrap: break-word;
  width: 110%;
}
.width40 {
  word-wrap: break-word;
  width: 40%;
}
.width50 {
  word-wrap: break-word;
  width: 50%;
}
.width60 {
  word-wrap: break-word;
  width: 60%;
}
.width70 {
  word-wrap: break-word;
  width: 70%;
}

.width75 {
  word-wrap: break-word;
  width: 75%;
}
.width25 {
  word-wrap: break-word;
  width: 25%;
}

.width80 {
  word-wrap: break-word;
  width: 80%;
}

.width85 {
  word-wrap: break-word;
  width: 85%;
}
.width90 {
  word-wrap: break-word;
  width: 90%;
}

.width100 {
  word-wrap: break-word;
  width: 100%;
}
.widthDesDetail {
  word-wrap: break-word;
  width: 110%;
}
.widthTotal {
  word-wrap: break-word;
  width: 140%;
}
.widthValOri {
  word-wrap: break-word;
  width: 40%;
}
.widthfull {
  width: 100%;
}
.widthVal {
  word-wrap: break-word;
  width: 243px;
}
.widthValOth {
  word-wrap: break-word;
  width: 183px;
}
@media print {
  /*
          body.A3.landscape { width: 420mm }
          body.A3, body.A4.landscape { width: 297mm }
          body.A4, body.A5.landscape { width: 210mm }
          body.A5 { width: 148mm }*/
  .printonly {
    display: block;
  }
  .noprint {
    display: none;
  }
  .A3.landscape {
    width: 420mm;
  }
  .A3,
  .A4.landscape {
    width: 297mm;
  }
  .A4,
  .A5.landscape {
    width: 210mm;
  }
  .A5 {
    width: 148mm;
  }
}
header {
  top: 0;
  padding-top: 150mm;
  padding-bottom: 3mm;
}
footer {
  bottom: 0;
  color: #000;
  padding-top: 3mm;
  padding-bottom: 5mm;
}
header,
footer {
  /* position: fixed; */
  left: 0;
  right: 0;
  background-color: #ccc;
  padding-right: 1.5cm;
  padding-left: 1.5cm;
}

.footerprpo {
  position: absolute;
  width: 100%;
}
.borderauto {
  border: 1px solid;
  margin: -1px;
}
.bordersignature {
  height: 110px;
  border: 1px solid;
  margin: -1px;
}
.full-width-td {
    width: 100%;
  }
.fixfourrow {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  height: 80px;
  overflow: hidden;
  text-align: left;
}
.higthR {
  height: 50px;
}
.higthRP {
  height: 10px;
}
.fixthreerow {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 60px;
  overflow: hidden;
  text-align: left;
}
.fixthreerownoheight {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
}
.fontweight700 {
  font-weight:700;
}

.fixtworow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
  overflow: hidden;
  text-align: left;
}
.fixonerow {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: left;
}
.fixonerownoheight {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
}
.fixonerowcenter {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: center;
}
.fontsize10 {
  font-size: 10px;
}
.fontsize12 {
  font-size: 12px;
}
.fontsize13 {
  font-size: 12px;
}

.borderwidththin {
  border-width: thin;
  border-color: darkgray;
}
.titledatadetailintable {
  font-weight: bold;
  text-decoration: underline;
}
.paddingleftintable {
  padding-left: 10px;
}
.paddingrightintable {
  padding-right: 10px;
}
.paddingtoptintable {
  padding-top: 10px;
}
.paddingrightintableleft {
  padding-left: 10px;
}
.paddingrightintableInv {
  padding-left: 50px;
}
.textalignright {
  text-align: right;
}
.textindent {
  text-indent: -20px;
}
.wordspacingsummary {
  /* word-spacing: -1px; */
  letter-spacing: 1px;
}
.fontsize14 {
  font-size: 14px;
}
.customClass >>> label {
  font-size: 13px;
  color: #000;
}

</style>
